import { useQueryClient } from '@tanstack/react-query';

import { useStable } from '~/src/common/hooks/useStable';
import { Cart } from '~/src/common/typings/cart';
import { getGetCartQueryKey } from '~/src/queries/api-ecom/generated/api-ecom';

export const useGetCartFromCache = () => {
  const queryClient = useQueryClient();

  return useStable(() => queryClient.getQueryData<Cart>(getGetCartQueryKey()));
};
